import Vue from 'vue';
import {Component, Emit, Prop, Watch} from 'vue-property-decorator';

@Component
class EdInputComponent extends Vue {
    @Prop({default: 'text'}) readonly type!: string;
    @Prop({default: '18px'}) readonly suffixIconFontSize!: string;
    @Prop({type: String, default: ''}) readonly label!: string;
    @Prop({type: String, default: ''}) readonly placeholder!: string;
    @Prop({type: Boolean, default: false}) readonly disabled!: boolean;
    @Prop({type: Boolean, default: false}) readonly readonly!: boolean;
    @Prop({type: Boolean, default: false}) readonly singleLine!: boolean;
    @Prop({type: Boolean, default: false}) readonly clearable!: boolean;
    @Prop({type: Boolean, default: false}) readonly labelFloating!: boolean;
    @Prop({type: Boolean, default: false}) readonly filled!: boolean;
    @Prop({type: Boolean, default: false}) readonly phoneExt!: boolean;
    @Prop({type: Boolean, default: false}) readonly positiveNumeric!: boolean;
    @Prop({type: Boolean, default: false}) readonly phoneNumber!: boolean;
    @Prop({type: Boolean, default: false}) readonly passwordIcon: boolean;
    @Prop({type: Boolean, default: false}) readonly inputTextCenter: boolean;
    @Prop({type: Boolean, default: false}) readonly onlyNumbers!: boolean;
    @Prop({type: Boolean, default: false}) readonly numberGreaterThanZero!: boolean;
    @Prop({type: Number, default: null}) readonly counter!: number | null;
    @Prop() readonly messages!: string[];
    @Prop({type: [String, Object], default: ''}) readonly value!: object;
    @Prop() readonly maxlength: number;

    private inputValue = this.value;

    public iconName: string = 'eye-slash-regular';
    public inputType: string = 'password';

    get typeInput() {
        return this.passwordIcon ? this.inputType : this.type;
    }

    get iconText() {
        return this.iconName === 'eye-regular'
            ? this.$t('auth.resetPassword.hidePassword')
            : this.$t('auth.resetPassword.showPassword');
    }

    get normalizedMessages() {
        if (!this.messages) return [];
        return Array.isArray(this.messages) ? this.messages : [this.messages];
    }

    get required() {
        let attrs: any = this.$attrs;
        if(attrs.validators) {
            return !!attrs.validators.required;
        }
        return this.$attrs?.required ?? false;
    }

    togglePassword() {
        const isPasswordVisible = this.inputType === 'text';
        this.iconName = isPasswordVisible ? 'eye-slash-regular' : 'eye-regular';
        this.inputType = isPasswordVisible ? 'password' : 'text';
    }

    @Watch('value', {immediate: true})
    onValueChange(newValue: any) {
        this.inputValue = newValue;
    }


    @Emit('keyup')
    onKeyUp(event): void {
    }

    @Emit('keydown')
    keydown(event) {
    }

    @Emit('focus')
    onFocus() {
    }

    @Emit('blur')
    onBlur() {
    }

    @Emit('input')
    onInput(value: any) {
        return value;
    }
}

export default Vue.component('ed-input', EdInputComponent);